import { defineMessages } from 'react-intl';

export default defineMessages({
  devNotice: {
    id: 'sku.modifiers.dev.devNotice',
    defaultMessage:
      'Dev-only tab, excluded from production. The design here is throwaway placeholder UI — its only job is to exercise the modifier gateway API calls. Reads and writes go through an in-memory mock (persisted to localStorage, so changes survive a refresh); no backend is called. The real authoring experience is built in SKU-687+.',
  },
  newGroupHeading: {
    id: 'sku.modifiers.dev.newGroupHeading',
    defaultMessage: 'New modifier group',
  },
  groupNameLabel: {
    id: 'sku.modifiers.dev.groupNameLabel',
    defaultMessage: 'Group name',
  },
  groupNamePlaceholder: {
    id: 'sku.modifiers.dev.groupNamePlaceholder',
    defaultMessage: 'e.g. Choose your sauce',
  },
  optionsLabel: {
    id: 'sku.modifiers.dev.optionsLabel',
    defaultMessage: 'Options',
  },
  optionsPlaceholder: {
    id: 'sku.modifiers.dev.optionsPlaceholder',
    defaultMessage: 'e.g. Ketchup, Mustard, Mayo',
  },
  optionsHint: {
    id: 'sku.modifiers.dev.optionsHint',
    defaultMessage: 'Separate options with commas. The first becomes the default.',
  },
  requiredLabel: {
    id: 'sku.modifiers.dev.requiredLabel',
    defaultMessage: 'Required (customer must pick at least one)',
  },
  createButton: {
    id: 'sku.modifiers.dev.createButton',
    defaultMessage: 'Create group',
  },
  listHeading: {
    id: 'sku.modifiers.dev.listHeading',
    defaultMessage: 'Modifier groups',
  },
  emptyState: {
    id: 'sku.modifiers.dev.emptyState',
    defaultMessage: 'No modifier groups yet. Create one on the left to get started.',
  },
  publishedBadge: {
    id: 'sku.modifiers.dev.publishedBadge',
    defaultMessage: 'Published',
  },
  unpublishedBadge: {
    id: 'sku.modifiers.dev.unpublishedBadge',
    defaultMessage: 'Unpublished ({reason})',
  },
  rulesRequired: {
    id: 'sku.modifiers.dev.rulesRequired',
    defaultMessage: 'Required · pick {min}–{max}',
  },
  rulesOptional: {
    id: 'sku.modifiers.dev.rulesOptional',
    defaultMessage: 'Optional · up to {max}',
  },
  defaultBadge: {
    id: 'sku.modifiers.dev.defaultBadge',
    defaultMessage: 'Default',
  },
  soldOutOn: {
    id: 'sku.modifiers.dev.soldOutOn',
    defaultMessage: 'Sold out',
  },
  soldOutOff: {
    id: 'sku.modifiers.dev.soldOutOff',
    defaultMessage: 'Available',
  },
  soldOutAria: {
    id: 'sku.modifiers.dev.soldOutAria',
    defaultMessage: 'Mark {name} sold out',
  },
  noOptions: {
    id: 'sku.modifiers.dev.noOptions',
    defaultMessage: 'No options yet — this group stays unpublished until it has one.',
  },
  loadError: {
    id: 'sku.modifiers.dev.loadError',
    defaultMessage: 'Failed to load modifier groups.',
  },
});
